/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelRecordData', 'model/ForecastModelRecordDataReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForecastModelRecordData'), require('../model/ForecastModelRecordDataReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelRecordDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelRecordData, root.ForStractionServiceApi.ForecastModelRecordDataReport);
  }
}(this, function(ApiClient, ForecastModelRecordData, ForecastModelRecordDataReport) {
  'use strict';

  /**
   * ForecastModelRecordData service.
   * @module api/ForecastModelRecordDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForecastModelRecordDataApi. 
   * @alias module:api/ForecastModelRecordDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the forecastModelRecordDataAddPut operation.
     * @callback module:api/ForecastModelRecordDataApi~forecastModelRecordDataAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelRecordData} body 
     * @param {module:api/ForecastModelRecordDataApi~forecastModelRecordDataAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.forecastModelRecordDataAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelRecordDataAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForecastModelRecordData/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataDeleteGet operation.
     * @callback module:api/ForecastModelRecordDataApi~forecastModelRecordDataDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/ForecastModelRecordDataApi~forecastModelRecordDataDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelRecordDataDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling forecastModelRecordDataDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelRecordData/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataEditPut operation.
     * @callback module:api/ForecastModelRecordDataApi~forecastModelRecordDataEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelRecordData} body 
     * @param {module:api/ForecastModelRecordDataApi~forecastModelRecordDataEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelRecordDataEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelRecordDataEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelRecordData/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataImportGet operation.
     * @callback module:api/ForecastModelRecordDataApi~forecastModelRecordDataImportGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * import
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/ForecastModelRecordDataApi~forecastModelRecordDataImportGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelRecordDataImportGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataImportGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling forecastModelRecordDataImportGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelRecordData/import', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataLoadAllGet operation.
     * @callback module:api/ForecastModelRecordDataApi~forecastModelRecordDataLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ForecastModelRecordDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/ForecastModelRecordDataApi~forecastModelRecordDataLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ForecastModelRecordDataReport>}
     */
    this.forecastModelRecordDataLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ForecastModelRecordDataReport];

      return this.apiClient.callApi(
        '/ForecastModelRecordData/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelRecordDataLoadGet operation.
     * @callback module:api/ForecastModelRecordDataApi~forecastModelRecordDataLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelRecordDataReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/ForecastModelRecordDataApi~forecastModelRecordDataLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelRecordDataReport}
     */
    this.forecastModelRecordDataLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelRecordDataLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling forecastModelRecordDataLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelRecordDataReport;

      return this.apiClient.callApi(
        '/ForecastModelRecordData/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
